document.addEventListener('DOMContentLoaded', function() {
  // Handle redirect to reviews section
  const redirectLinks = document.querySelectorAll('.redirect-jdgm');

  redirectLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      // Find the Judge.me reviews section
      const reviewsSection = document.querySelector('#shopify-section-17647693552c83f733');

      if (reviewsSection) {
        // Scroll to the section with smooth behavior
        reviewsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        // Optional: Add a small offset from the top (useful if you have a fixed header)
        setTimeout(() => {
          const yOffset = -80; // Adjust this value based on your header height
          const y = reviewsSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 100);
      }
    });
  });
});
